<div
  class="form-group"
  [class.required]="isRequired"
  [formGroup]="parentForm"
  *ngIf="control"
>
  <mat-form-field
    [floatLabel]="'always'"
    appearance="fill"
    [class.readonly]="readOnlyCss"
  >
    <mat-label>{{ title }}</mat-label>

    <input
      matInput
      appTrim
      appOnlyLetters
      *ngIf="!capitalizeAll"
      [class.is-invalid]="control.invalid && control.touched"
      type="text"
      class="form-control form-control-sm"
      [formControlName]="formControlName"
    />

    <input
      matInput
      appTrim
      appOnlyLetters
      appCapitalizeAll
      *ngIf="capitalizeAll"
      [class.is-invalid]="control.invalid && control.touched"
      type="text"
      class="form-control form-control-sm"
      [formControlName]="formControlName"
    />

    <span
      class="success-mark"
      *ngIf="control.value && !control.errors && !control.hideSuccessMark"
    >
      <fa-icon [icon]="faCheck"></fa-icon>
    </span>

    <mat-error *ngIf="!control.hideErrorMessages">
      <span *ngIf="control.errors?.required">{{ requiredText }}</span>
      <span *ngIf="control.errors?.maxlength">
        {{ 'Common.MaxLengthError' | labelText }}
      </span>
    </mat-error>
  </mat-form-field>
</div>
